var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstKeyImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.612372,
    y: 14.8418,
    width: 54.9857,
    height: 55.005,
    rx: 8.5,
    transform: "rotate(-15 0.612372 14.8418)",
    fill: "#241A57",
    fillOpacity: 0.53,
    stroke: "url(#paint0_linear_1877_15315)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3671 29.3684L30.2093 30.2105M31.0515 36.1053C29.9607 36.1049 28.8992 35.7516 28.0258 35.0982C27.1524 34.4447 26.5139 33.5262 26.2058 32.4799C25.8977 31.4336 25.9364 30.3157 26.3162 29.2932C26.6961 28.2708 27.3966 27.3987 28.3132 26.8073C29.2297 26.2158 30.3131 25.9369 31.4013 26.012C32.4895 26.0872 33.5243 26.5124 34.3508 27.2242C35.1773 27.936 35.7513 28.8961 35.987 29.961C36.2227 31.026 36.1073 32.1386 35.6583 33.1326L42 39.4737L42 42L39.4734 42L39.4734 40.3158L37.789 40.3158L37.789 38.6316L36.1046 38.6316L33.1317 35.659C32.4967 35.9453 31.7926 36.1053 31.0515 36.1053Z",
    stroke: "#7057EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_15315",
    x1: 27.9928,
    y1: 14.4883,
    x2: 28.3663,
    y2: 79.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7057F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249483,
    stopColor: "#6E5BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#666666",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstKeyImg);
export default __webpack_public_path__ + "static/media/FirstKeyImg.4b1de59e830ed7f149c55c6f385633fd.svg";
export { ForwardRef as ReactComponent };